import { render, staticRenderFns } from "./clientsdb.vue?vue&type=template&id=31cdf738&"
import script from "./clientsdb.vue?vue&type=script&lang=js&"
export * from "./clientsdb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports